import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useEffect } from "react";
import moment from "moment-timezone";

export const TARIFAS = {
  MOTO: {
    value: "25.00",
    label: "MOTO - $25.00",
  },
  SEDAN_PICKUP: {
    value: "60.00",
    label: "SEDAN PICKUP, CERRADA - $60.00",
  },
  VEHICULO_3_5_TON: {
    value: "75.00",
    label: "SERV. ARRASTRE DE VEHICULO 3.5 TON - $75.00",
  },
  URBANO: {
    value: "100.00",
    label: "URBANO - $100.00",
  },
  TRACTO_REMOLQUE: {
    value: "150.00",
    label: "TRACTO - REMOLQUE- $150.00",
  },
};

function ServiceDetails({ values, setFieldValue, errors }) {
  //console.log("Render ", values.montosExtras);

  const handleServicioChange = ({
    e,
    setFieldValue,
    values,
    fieldName,
    fieldDe,
    fieldA,
    id_value,
    labelInicio,
    labelFin,
  }) => {
    const value = e.target.value;
    const updatedValues = { ...values, [fieldName]: value };
    setFieldValue(fieldName, value);

    const valDe = updatedValues[fieldDe];
    const valA = updatedValues[fieldA];

    const newMontos = [...values.montosExtras];
    const index = newMontos.findIndex((m) => m.id_value === id_value);

    let descripcion = "";
    if (valDe && valA) {
      descripcion = `${labelInicio} ${valDe} a ${valA}`;
    } else if (valDe) {
      descripcion = `${labelInicio} ${valDe}`;
    } else if (valA) {
      descripcion = `${labelFin} ${valA}`;
    }

    if (descripcion) {
      const nuevaEntrada = {
        id_value,
        monto_extra_descripcion: descripcion,
        monto_extra_monto: "",
      };
      if (index !== -1) {
        newMontos[index] = nuevaEntrada;
      } else {
        newMontos.push(nuevaEntrada);
      }
    } else if (index !== -1) {
      newMontos.splice(index, 1);

      // Limpiar campos si aplica
      if (id_value === "primerServicio") {
        setFieldValue("primerServDe", "");
        setFieldValue("primerServA", "");
      } else if (id_value === "segundoServicio") {
        setFieldValue("segundoServDe", "");
        setFieldValue("segundoServA", "");
      }
    }

    setFieldValue("montosExtras", newMontos);
  };

  useEffect(() => {
    const tarifaClave = values.tarifa_seleccionada;
    const fechaOrden = values.fecha_hora_orden;
    const generaCosto = values.genera_costo_por_estadia;
    const estatus = values.estatus;

    // Salir si la orden está cancelada o pagada
    if (estatus === "Cancelado" || estatus === "Pagado") {
      return;
    }

    if (!generaCosto || !tarifaClave || !fechaOrden) {
      const newMontos = values.montosExtras.filter(
        (item) => item.id_value !== "costo_estadia_tarifa"
      );
      setFieldValue("montosExtras", newMontos);
      return;
    }

    const calcularEstadia = () => {
      if (!tarifaClave || !fechaOrden || !generaCosto) return;

      const tarifa = parseFloat(TARIFAS[tarifaClave]?.value);
      const descTarifa = TARIFAS[tarifaClave]?.label;

      if (isNaN(tarifa)) return;

      const fechaOrdenMoment = moment.tz(fechaOrden, "America/Mexico_City");
      const ahora = moment.tz("America/Mexico_City");

      const duracion = moment.duration(ahora.diff(fechaOrdenMoment));
      let diasTranscurridos = Math.floor(duracion.asDays());

      //if (diasTranscurridos <= 0) return;
      // Si es 0 o negativo, forzar a 1 día mínimo
      if (diasTranscurridos <= 0) {
        diasTranscurridos = 1;
      }

      const montoEstadia = diasTranscurridos * tarifa;

      const newMontos = [...values.montosExtras];
      const index = newMontos.findIndex(
        (item) => item.id_value === "costo_estadia_tarifa"
      );

      const nuevaEntrada = {
        id_value: "costo_estadia_tarifa",
        monto_extra_descripcion: `Estadía (${descTarifa} x ${diasTranscurridos} días)`,
        monto_extra_monto: montoEstadia.toFixed(2),
      };

      if (index !== -1) {
        newMontos[index] = nuevaEntrada;
      } else {
        newMontos.push(nuevaEntrada);
      }

      setFieldValue("montosExtras", newMontos);
    };

    calcularEstadia();
  }, [
    values.tarifa_seleccionada,
    values.fecha_hora_orden,
    values.genera_costo_por_estadia,
  ]);

  return (
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>1er serv. de</Form.Label>
          <Form.Control
            type="text"
            name="primerServDe"
            placeholder="1er serv. de"
            value={values.primerServDe}
            onChange={(e) =>
              handleServicioChange({
                e,
                setFieldValue,
                values,
                fieldName: "primerServDe",
                fieldDe: "primerServDe",
                fieldA: "primerServA",
                id_value: "primerServicio",
                labelInicio: "1er serv. de",
                labelFin: "1er serv. a",
              })
            }
            isInvalid={!!errors.primerServDe}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>1er serv. a</Form.Label>
          <Form.Control
            type="text"
            name="primerServA"
            placeholder="1er serv. a"
            value={values.primerServA}
            onChange={(e) =>
              handleServicioChange({
                e,
                setFieldValue,
                values,
                fieldName: "primerServA",
                fieldDe: "primerServDe",
                fieldA: "primerServA",
                id_value: "primerServicio",
                labelInicio: "1er serv. de",
                labelFin: "1er serv. a",
              })
            }
            isInvalid={!!errors.primerServA}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>2° serv. de</Form.Label>
          <Form.Control
            type="text"
            name="segundoServDe"
            placeholder="2° serv. de"
            value={values.segundoServDe}
            onChange={(e) =>
              handleServicioChange({
                e,
                setFieldValue,
                values,
                fieldName: "segundoServDe",
                fieldDe: "segundoServDe",
                fieldA: "segundoServA",
                id_value: "segundoServicio",
                labelInicio: "2° serv. de",
                labelFin: "2° serv. a",
              })
            }
            isInvalid={!!errors.segundoServDe}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>2° serv. a</Form.Label>
          <Form.Control
            type="text"
            name="segundoServA"
            placeholder="2° serv. a"
            value={values.segundoServA}
            onChange={(e) =>
              handleServicioChange({
                e,
                setFieldValue,
                values,
                fieldName: "segundoServA",
                fieldDe: "segundoServDe",
                fieldA: "segundoServA",
                id_value: "segundoServicio",
                labelInicio: "2° serv. de",
                labelFin: "2° serv. a",
              })
            }
            isInvalid={!!errors.segundoServA}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            label="Genera costo por estadía"
            name="genera_costo_por_estadia"
            checked={values.genera_costo_por_estadia}
            onChange={(e) => {
              setFieldValue("genera_costo_por_estadia", e.target.checked);
              if (!e.target.checked) {
                setFieldValue("tarifa_seleccionada", "");
              }
            }}
            disabled={!values.fecha_hora_orden}
          />
          {!values.fecha_hora_orden && (
            <div className="text-danger mt-1" style={{ fontSize: "0.9em" }}>
              Debes seleccionar una fecha y hora de orden primero.
            </div>
          )}
        </Form.Group>

        {values.genera_costo_por_estadia && (
          <Form.Group className="mb-3">
            <Form.Label>Selecciona una tarifa</Form.Label>
            <Form.Select
              name="tarifa_seleccionada"
              value={values.tarifa_seleccionada}
              onChange={(e) =>
                setFieldValue("tarifa_seleccionada", e.target.value)
              }
              isInvalid={!!errors.tarifa_seleccionada}
            >
              <option value="">-- Selecciona una tarifa --</option>
              {Object.entries(TARIFAS).map(([clave, tarifa]) => (
                <option key={clave} value={clave}>
                  {tarifa.label}
                </option>
              ))}
            </Form.Select>

            <Form.Control.Feedback type="invalid">
              {errors.tarifa_seleccionada}
            </Form.Control.Feedback>
          </Form.Group>
        )}
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Oficial que ordena el servicio</Form.Label>
          <Form.Control
            type="text"
            name="oficialOrdenaServicio"
            placeholder="Oficial que ordena el servicio"
            value={values.oficialOrdenaServicio}
            onChange={(e) =>
              setFieldValue("oficialOrdenaServicio", e.target.value)
            }
            isInvalid={!!errors.oficialOrdenaServicio}
          />
          <Form.Control.Feedback type="invalid">
            {errors.oficialOrdenaServicio}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Perito / Comandante de conocimiento</Form.Label>
          <Form.Control
            type="text"
            name="peritoComandanteDeConocimiento"
            placeholder="Perito / Comandante de conocimiento"
            value={values.peritoComandanteDeConocimiento}
            onChange={(e) =>
              setFieldValue("peritoComandanteDeConocimiento", e.target.value)
            }
            isInvalid={!!errors.peritoComandanteDeConocimiento}
          />
          <Form.Control.Feedback type="invalid">
            {errors.peritoComandanteDeConocimiento}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Nombre del infractor</Form.Label>
          <Form.Control
            type="text"
            name="nombreInfractor"
            placeholder="Nombre del infractor"
            value={values.nombreInfractor}
            onChange={(e) => setFieldValue("nombreInfractor", e.target.value)}
            isInvalid={!!errors.nombreInfractor}
          />
          <Form.Control.Feedback type="invalid">
            {errors.nombreInfractor}
          </Form.Control.Feedback>
        </Form.Group>
        <Row>
          {[
            { name: "horaDeEspera", label: "Hora de Espera" },
            { name: "acondicionamiento", label: "Acondicionamiento" },
            { name: "estadia", label: "Estadía" },
            { name: "cargaVaroExpress", label: "Carga" },
            { name: "abanderamiento", label: "Abanderamiento" },
            { name: "custodia", label: "Custodia" },
          ].map(({ name, label }) => (
            <Col md={6} key={name}>
              <Form.Group className="mb-2">
                <Form.Check
                  type="switch"
                  name={name}
                  label={label}
                  checked={values.montosExtras.some(
                    (item) => item.id_value === name
                  )}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const newMontos = [...values.montosExtras];
                    const index = newMontos.findIndex(
                      (item) => item.id_value === name
                    );

                    if (checked) {
                      if (index === -1) {
                        newMontos.push({
                          id_value: name,
                          monto_extra_descripcion: label,
                          monto_extra_monto: "",
                        });
                      }
                    } else {
                      if (index !== -1) {
                        newMontos.splice(index, 1);
                      }
                    }

                    setFieldValue("montosExtras", newMontos);
                  }}
                />
              </Form.Group>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
}

export default ServiceDetails;
